var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardworkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#FFE3BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3995 33.5606C57.3195 34.0606 57.2795 34.5606 57.2795 35.0606C57.2795 39.5606 60.9195 43.1986 65.3995 43.1986C65.8995 43.1986 66.3795 43.1406 66.8795 43.0606V59.1986C66.8795 65.9806 62.8795 70.0006 56.0795 70.0006H41.3015C34.4995 70.0006 30.4995 65.9806 30.4995 59.1986V44.4006C30.4995 37.6006 34.4995 33.5606 41.3015 33.5606H57.3995ZM57.8015 45.7206C57.2595 45.6606 56.7215 45.9006 56.3995 46.3406L51.5615 52.6006L46.0195 48.2406C45.6795 47.9806 45.2795 47.8786 44.8795 47.9206C44.4815 47.9806 44.1215 48.1986 43.8795 48.5186L37.9615 56.2206L37.8395 56.4006C37.4995 57.0386 37.6595 57.8586 38.2595 58.3006C38.5395 58.4806 38.8395 58.6006 39.1795 58.6006C39.6415 58.6206 40.0795 58.3786 40.3595 58.0006L45.3795 51.5386L51.0795 55.8206L51.2595 55.9386C51.8995 56.2786 52.6995 56.1206 53.1595 55.5186L58.9395 48.0606L58.8595 48.1006C59.1795 47.6606 59.2395 47.1006 59.0195 46.6006C58.8015 46.1006 58.3195 45.7606 57.8015 45.7206ZM65.6797 30C68.3397 30 70.4997 32.16 70.4997 34.82C70.4997 37.48 68.3397 39.64 65.6797 39.64C63.0197 39.64 60.8597 37.48 60.8597 34.82C60.8597 32.16 63.0197 30 65.6797 30Z",
    fill: "#573E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardworkspace);
export default __webpack_public_path__ + "static/media/dashboardworkspace.7319f18c075ec2455a0dfc3a9071d978.svg";
export { ForwardRef as ReactComponent };